import { MessageInstance } from 'antd/es/message/interface'
import { HookAPI } from 'antd/es/modal/useModal'
import { action, makeObservable, observable, runInAction } from 'mobx'
import { GoodsDetailModalProps } from '@/components/GoodsDetailModal'
import { OpenVipModalProps } from '@/components/OpenVipModal'
import { BuyPopupProps } from '@/components/mobile/BuyPopup'
import eruda from 'eruda'
import { ContactPopupProps } from '@/components/mobile/ContactPopup'
import { LoginDialogProps } from '@/components/mobile/LoginDialog/LoginDialog'
import { PaySuccessPopupProps } from '@/components/mobile/PaySuccessPopup'
import { PayingPopupProps } from '@/components/mobile/PayingPopup'
import { PayModalProps } from '@/components/PayModal'
import { CustomerServiceModalProps } from '@/components/CustomerServiceModal'
import { ExchangeCodeModalProps, ExchangeSuccessModalProps } from '@/components/ExchangeCodeModal'
import { CustomMadeModalProps } from '@/components/CustomMadeModal'
import { LoginModalProps } from '@/components/LoginModal'
import { PaySuccessModalProps } from '@/components/PaySuccessModal'
import { PayHelper } from '@/helpers/payHelper'
import { userService } from '@/services/userService'
import emitter, { EmitterEvents ,MobileEmitterEvents} from '@/helpers/emitter'
import { commonUtils } from '@/helpers/commonUtils'
import { Dialog} from 'antd-mobile'
// 登录装饰器
export function Login(runAfterLogin: boolean = true) {
  return function (_target: any, _propertyKey: string, descriptor: any) {
    const origin = descriptor.value
    descriptor.value = async function (...args: any[]) {
      if (!userService.isLogin) {
        if (uiController.tipWechat()) {
          return
        }

        uiController.loginModalProps.visible = true
        if (runAfterLogin) {
          return new Promise((resolve) => {
            emitter.once(EmitterEvents.LOGIN_SUCCESS, () => {
              resolve(origin.apply(this, args))
            })
          })
        }
      } else {
        return origin.call(this, ...args)
      }
    }
  }
}

class UiController {
  @observable message!: MessageInstance
  @observable modal!: HookAPI
  @observable test = false

  // 登陆弹窗
  @observable loginModalProps: LoginModalProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.loginModalProps.visible = false
      })
    },
  }

   // 移动端购买弹窗
   @observable buyPopupProps: BuyPopupProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.buyPopupProps.visible = false
      })
    },
  }

  // 详情弹窗
  @observable goodsDetailModalProps: GoodsDetailModalProps = {
    visible: false,
    materialId: 0,
    onClose: () => {
      runInAction(() => {
        this.goodsDetailModalProps.visible = false
      })
    },
  }

  // 开通会员
  @observable openVipModalProps: OpenVipModalProps = {
    visible: false,
    detail: {} as ServerData.PptData,
    payHelper: new PayHelper(),
    onClose: () => {
      runInAction(() => {
        this.openVipModalProps.payHelper.closePay()
        this.openVipModalProps.visible = false
      })
    },
    onPaySuccess: (timeType: string) => {
      userService.getUserInfo()
      emitter.emit(EmitterEvents.PAY_SUCCESS)
      const timeName = timeType === 'year' ? '年' : timeType === 'month' ? '月' : ''
      uiController.openPaySuccess({
        title: `恭喜你成功开通${timeName}会员，快去下载使用模版吧`,
        materialId: this.openVipModalProps.detail?.id,
        materialName: `${this.openVipModalProps.detail?.name}.${this.openVipModalProps.detail?.fileType}`,
      })
    },
  }

  // 单个购买
  @observable payModalProps: PayModalProps = {
    visible: false,
    detail: {} as ServerData.PptData,
    payHelper: new PayHelper(),
    onClose: () => {
      runInAction(() => {
        this.payModalProps.payHelper.closePay()
        this.payModalProps.visible = false
      })
    },
    onPaySuccess: () => {
      userService.getUserInfo()
      emitter.emit(EmitterEvents.PAY_SUCCESS)
      uiController.openPaySuccess({
        title: '恭喜你成功购买该模版，快去下载使用模版吧',
        materialId: this.payModalProps.detail.id,
        materialName: `${this.payModalProps.detail.name}.${this.payModalProps.detail.fileType}`,
      })
    },
  }

  // 客服弹窗
  @observable customerServiceModalProps: CustomerServiceModalProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.customerServiceModalProps.visible = false
      })
    },
  }

  // 兑换码弹窗
  @observable exchangeCodeModalProps: ExchangeCodeModalProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.exchangeCodeModalProps.visible = false
      })
    },
  }

  // 兑换成功弹窗
  @observable exchangeSuccessModalProps: ExchangeSuccessModalProps = {
    visible: false,
    type: 'noce',
    onClose: () => {
      runInAction(() => {
        this.exchangeSuccessModalProps.visible = false
      })
    },
  }

  // 支付成功弹窗
  @observable paySuccessModalProps: PaySuccessModalProps = {
    visible: false,
    title: '恭喜你成功购买该模版，快去下载使用模版吧',
    materialId: undefined,
    onClose: () => {
      runInAction(() => {
        this.paySuccessModalProps.visible = false
      })
    },
  }

  @observable customMadeModalProps: CustomMadeModalProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.customMadeModalProps.visible = false
      })
    },
  }

  public init() {
    makeObservable(this)
    if ((process.env.NODE_ENV==='development') && commonUtils.isMobile()) {
      eruda.init()
    }
  }

  @Login()
  @action
  openVipModal(detail?: ServerData.PptData) {
    this.openVipModalProps.visible = true
    this.openVipModalProps.detail = detail
  }

  @Login()
  @action
  openPayModal(detail: ServerData.PptData) {
    this.payModalProps.visible = true
    this.payModalProps.detail = detail
  }

  @Login()
  @action
  openPaySuccess({
    title,
    materialId,
    materialName,
  }: {
    title: string
    materialId?: number
    materialName?: string
  }) {
    this.paySuccessModalProps.visible = true
    this.paySuccessModalProps.title = title
    this.paySuccessModalProps.materialId = materialId
    this.paySuccessModalProps.materialName = materialName
  }

  @Login()
  @action
  openExchangeCodeModal() {
    this.exchangeCodeModalProps.visible = true
  }

    // 移动端支付弹窗
    @observable payingPopupProps: PayingPopupProps = {
      visible: false,
      onClose: () => {
        runInAction(() => {
          this.payingPopupProps.visible = false
        })
      },
    }
  
    // 移动端支付成功弹窗
    @observable paySuccessPopupProps: PaySuccessPopupProps = {
      visible: false,
      onClose: () => {
        runInAction(() => {
          this.paySuccessPopupProps.visible = false
        })
      },
    }

  @action
  openExchangeSuccessModal(type: ExchangeSuccessModalProps['type']) {
    this.exchangeSuccessModalProps.type = type
    this.exchangeSuccessModalProps.visible = true
  }

  @action
  openPaySuccessPopup(download: boolean | (() => void) = false) {
    this.paySuccessPopupProps.visible = true
    this.paySuccessPopupProps.onDownload = download
  }

  // 移动端联系客服弹窗
  @observable contactPopupProps: ContactPopupProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.contactPopupProps.visible = false
      })
    },
  }

  // 领取课件二维码
  @observable downloadConsultationQrCodePopupProps: ContactPopupProps = {
    visible: false,
    title: '领取课件',
    description: '添加客服领取课件～',
    onClose: () => {
      runInAction(() => {
        this.downloadConsultationQrCodePopupProps.visible = false
      })
    },
  }

  // 移动端登录弹窗
  @observable loginDialogProps: LoginDialogProps = {
    visible: false,
    onClose: () => {
      runInAction(() => {
        this.loginDialogProps.visible = false
      })
    },
    onLoginSuccess: () => {
      emitter.emit(MobileEmitterEvents.MOBILE_LOGIN_SUCCESS)
      runInAction(() => {
        this.loginDialogProps.visible = false
      })
    },
  }

  tipWechat() {
    if (commonUtils.isWechat() &&commonUtils.isMobile() ) {
      Dialog.confirm({
        title: '提示',
        content:
          '检测到您正在使用微信内置浏览器，可能导致下载失败或体验不佳，请前往浏览器中打开登录使用。',
          confirmText: '复制链接',
        cancelText: '取消',
        onConfirm: () => {
          commonUtils.copyToClipboard(window.location.href)
          uiController.message.info('已复制链接，请前往浏览器中打开')
        },
      })
      return true
    } else {
      return false
    }
  }

}

export const uiController = new UiController()
